import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { setCurrentStep, setUserDetails, setSelectedPlan, setProducts } from './OrganizationPortalSlice';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import SalePackages from '../SalePackagesBlock/SalePackages';
import Checkbox from '../../Shared/CheckBox/Checkbox';
import { PortalStep } from './Enum';
import { prepareUrl } from '../../../utilities/StringHelpers/StringHelpers';
import EpiContext from '@episerver/spa-core/Spa';
import { setSelectedPackage } from '../SalePackagesBlock/salePackagesBlockSlice';

function OrgPlanSelection(props) {
  const [termChecked, setTermChecked] = useState(props.selectedPlan.package.packageId !== "");
  const [error, setError] = useState();
  const OrgPackages = props.orgDetails.orgPlans.map((plan) => plan.package);
  const isUpdateAction = props.userDetails.ban != '';
  const isUpgradeAction = props.userDetails.actionType === 'upgrade';
  const currentOrgPackage = OrgPackages.find((pkg) => pkg.offerID.value == props.userDetails.planCode);
  useEffect(() => {
    if (props.orgDetails.orgPlans.length == 1) {
      onSelectedPackages();
    } else if (isUpdateAction && !props.selectedPlan?.package.packageId) {
      if (props.userDetails.planCode != '') {
        var selectedPackageId = OrgPackages.findIndex((p) => p.offerID.value == props.userDetails.planCode);
        if (selectedPackageId != -1) {
          onSelectedPackages(selectedPackageId);
        }
      }
    }
  }, []);

  const onSelectedPackages = (index = 0) => {
    var parser = new DOMParser();
    var packageName = parser.parseFromString(OrgPackages[index].title.value, 'text/html').body.textContent;
    var price = OrgPackages[index].price.value;
    props.setSelectedPlan({ package: { packageId: OrgPackages[index].offerID.value, packageName, price } });
    props.setProducts([...props.orgDetails.orgPlans[index].orgPortalProducts]);
    setTermChecked(false);
    setError('');
    //selected sale package
    var salePackage = OrgPackages[index];
    salePackage = { ...salePackage, offerID: OrgPackages[index].offerID.value };
    props.setSelectedPackage(salePackage);
  }


  const goToNextPage = () => {
    if ((props.selectedPlan.packageId != '') && !isUpgradeAction) {
      if (termChecked) {
        if (props.products.length > 0) {
          props.setCurrentStep({ current: PortalStep.ProductSelection, previous: props.currentStep });
        } else {
          props.setCurrentStep({ current: PortalStep.DistributionCenter, previous: props.currentStep });
        }
      }
      else {
        setError('אנא אשר את תנאי השימוש ועקרי ההסכם');
      }
    } else if (isUpgradeAction) {
      if (props.products.length > 0) {
        props.setCurrentStep({ current: PortalStep.ProductSelection, previous: props.currentStep });
      } else {
        props.setCurrentStep({ current: PortalStep.DistributionCenter, previous: props.currentStep });
      }
    }
    else {
      setError('אנא בחר חבילה');
    }
  }


  return (
    <div className='step-page_M PlanSelection'>

      <div className='Org_SalePackages section'>
        <div className='M_Title'> אשרו את חבילת הסלולר שלכם</div>
        {!isUpgradeAction && (<SalePackages
          packages={{
            expandedValue: OrgPackages,
            isAbroadPackages: false,
          }}
          isSwiper={true}
          onSelectedPackages={onSelectedPackages}
          isOrgPlan={true}
        />)}
        {isUpgradeAction && currentOrgPackage && (<SalePackages
          packages={{
            expandedValue: [currentOrgPackage],
            isAbroadPackages: false,
          }}
          isSwiper={true}
          onSelectedPackages={onSelectedPackages}
          isOrgPlan={true}
        />)}
      </div>
      {props.selectedPackage && !isUpgradeAction && (
        <div className='term-condition'>
          <Checkbox
            id='terms-checkbox'
            onCheck={() => { setTermChecked(true); setError('') }}
            onUncheck={() => setTermChecked(false)}
            checked={termChecked}>
            <span> אני מאשר\ת את </span>
            <a className='term-link' href='#' onClick={() => prepareUrl(props.selectedPackage.termsLink.value, EpiContext)}>תנאי החבילה  </a>
          </Checkbox>
        </div>
      )}
      <div className='btn-container'>
        {error && <p className='error-msg mt-3'>{error}</p>}
        <BtnSubmit text={'אפשר להתקדם'} onclick={() => goToNextPage()} />
      </div>

    </div>
  );
}
const mapStateToProps = (state) => ({
  currentStep: state.organizationPortal.steps.current,
  userDetails: state.organizationPortal.userDetails,
  orgDetails: state.organizationPortal.orgDetails,
  selectedPlan: state.organizationPortal.userDetails.selectedPlan,
  products: state.organizationPortal.products,
  selectedPackage: state.SalePackagesBlock.selectedPackage,

});

const mapDispatchToProps = {
  setCurrentStep,
  setUserDetails,
  setSelectedPlan,
  setProducts,
  setSelectedPackage
};

export default connect(mapStateToProps, mapDispatchToProps)(OrgPlanSelection);
